import { render } from "./test-registration.vue?vue&type=template&id=b904a61e&scoped=true"
import script from "./test-registration.vue?vue&type=script&lang=js"
export * from "./test-registration.vue?vue&type=script&lang=js"

import "./test-registration.vue?vue&type=style&index=0&id=b904a61e&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b904a61e"]])

export default __exports__